// Copyright © 2021 Move Closer

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export enum UiDataCircleSize {
  Big = 'big',
  Small = 'small'
}
